


















import Vue from 'vue';
import AttachmentGrid from './attachment.grid.vue';
import { Component } from 'vue-property-decorator';
import { VHeaders } from '@/models/pagedlistmodel';
import {
  SearchRepairOrderViewModel,
  AddAttachmentModel,
  AttachmentInfoViewModel,
  RepairOrderResponseViewModel,
} from '@/models/fixedops/repairorder';
import { VFields } from '@/models/v-fields';
import { AttachmentType } from '@/models/fixedops/attachment';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '../common/base';
import { attachmentTypeService, repairOrderService } from '@/shared';
import { FileHelper } from '@/helper/file.helper';

@Component({
  data() {
    return {
      repairOrder: null,
    };
  },
  props: [
    'searchedRepairOrder',
    'roNumber',
    'openRepairOrders',
    'methodName',
    'childProgress',
  ],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    AttachmentGrid,
  },
})
class SaveAttachmentComponent extends Base {
  public isPageLoading: boolean = true;
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public flags: any = {
    showForm: false,
    showAttachmentDetails: false,
    showEmailPopup: false,
    showCallGrid: true,
    showTextGrid: true,
    showAttachmentGrid: true,
  };

  public roNumber: string;
  public repairOrder: any;
  public preventPaginationCall: boolean = false;
  public fileRef: any;

  public searchedRepairOrder: SearchRepairOrderViewModel;
  public openRepairOrders: RepairOrderResponseViewModel;
  public addAttachmentTypeModel: AddAttachmentModel = { isPublic: false };
  public attachmentDetails: AttachmentInfoViewModel[] = [];
  public attachmentTypes: AttachmentType[] = [];

  public isSaveAttachmentLoading: boolean = false;

  public headers: VHeaders[] = [
    { align: 'left', sortable: false, text: 'RO#', value: 'repairOrderNumber' },
    {
      align: 'left',
      sortable: false,
      text: 'Customer Name',
      value: 'customerName',
    },
    { align: 'left', sortable: false, text: 'VIN', value: 'vin' },
    {
      align: 'left',
      sortable: false,
      text: 'Close Date',
      value: 'finalCloseDate',
      fieldType: 'date',
      format: 'MMM Do YY',
    },
    {
      align: 'left',
      sortable: false,
      text: 'Status',
      value: `finalCloseDate?'Closed':'Open'`,
    },
    {
      align: 'left',
      sortable: false,
      text: 'Service Writer',
      value: `serviceWriter`,
    },
    { align: 'center', sortable: false, text: 'Actions', isNotDataProp: true },
  ];

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.cancel();
    } else if (methodName === 'submit') {
      if (this.form.$valid) {
        this.saveAttachment();
      } else {
        this.showAlert(
          false,
          this.$t('repairOrderAttachments.alertFormIsInvalid')
        );
      }
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '1',
      type: 'button',
      title: this.$parent.$t('repairOrderAttachments.btnBackToList'),
      disaled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('repairOrderAttachments.btnBackToList'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateChildToolBar', buttons);
  }
  public async mounted() {
    this.flags.showAttachmentDetails = true;
    this.$root.$emit('toggleAttachMentGridLoading', true);
    this.setFields(() => { });
    this.formlyShowSkeleton(this.formFields);

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (this.roNumber) {
      await this.attachmentByRoNumber(this.roNumber);
    }
    this.formlyHideSkeleton(this.formFields);

  }
  public async attachmentByRoNumber(roNumber) {
    if (this.searchedRepairOrder) {
      this.repairOrder = this.searchedRepairOrder.repairOrderList.find((m) => {
        return m.repairOrderNumber === roNumber;
      });
    } else {
      this.repairOrder = this.openRepairOrders.openRepairOrders.find((m) => {
        return m.repairOrderNumber === roNumber;
      });
    }
    if (this.repairOrder) {
      this.repairOrder.storeName = (
        this.searchedRepairOrder || this.openRepairOrders
      ).storeName;
      this.repairOrder.showCallDetails = (
        this.searchedRepairOrder || this.openRepairOrders
      ).showCallDetails;
      await this.viewAttachment(this.repairOrder);
    }
  }

  public async viewAttachment(model): Promise<void> {
    this.isPageLoading = true;
    this.addAttachmentTypeModel = {
      customerName: model.customerName,
      roNumber: model.repairOrderNumber,
      vehicleIdNumber: model.vin,
      attachmentTypeId: 0,
      comment: '',
      file: '',
      fileExtension: '',
      make: model.make,
      model: model.model,
    };

    this.setFields(() => { });

    // run both together
    await Promise.all([
      this.getAttachmentTypes(),
      this.getAttachmentDetails()
    ]);
    this.isPageLoading = false;

  }

  public async getAttachmentTypes(): Promise<void> {
    const response = await attachmentTypeService.getAttachmentTypesListAsync();
    this.attachmentTypes = response.results;
    this.setAttachmentTypeItems('attachmentTypeId', this.attachmentTypes);

  }
  public setAttachmentTypeItems(fieldname: string, value: any[]) {
    const field = this.formFields.find((m) => {
      return m.key === fieldname;
    });
    if (field) {
      field.templateOptions.items = value;
    }
  }

  public validateAttachment(): Vue & { validate: () => boolean } {
    return this.$refs.attachmentForm as Vue & { validate: () => boolean };
  }

  public async saveAttachment(): Promise<void> {
    if (this.validateAttachment().validate()) {
      try {
        this.isSaveAttachmentLoading = true;
        this.$emit('update:childProgress', this.isSaveAttachmentLoading);
        await repairOrderService.addAttachment(this.addAttachmentTypeModel);
      } finally {
        this.isSaveAttachmentLoading = false;
        this.$emit('update:childProgress', this.isSaveAttachmentLoading);
      }

      this.showAlert(
        true,
        this.$t('repairOrderAttachments.alertAttachmentCreated')
      );
      this.addAttachmentTypeModel.file = null;
      this.addAttachmentTypeModel.attachmentTypeId = 0;
      this.addAttachmentTypeModel.comment = '';
      if (this.fileRef) {
        this.fileRef.clear();
      }
      this.getAttachmentDetails();
    }
  }
  public async getAttachmentDetails(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const response = await repairOrderService.getAttachmentDetails(
        this.roNumber,
        this.addAttachmentTypeModel.vehicleIdNumber
      );
      this.attachmentDetails = response.results;
      this.attachmentDetails = this.attachmentDetails.sort((a, b) => {
        if (a.createdDateTime < b.createdDateTime) {
          // sort string ascending
          return 1;
        }
        if (a.createdDateTime > b.createdDateTime) {
          return -1;
        }
      });

      this.flags.showForm = true;
    } finally {
      this.formlyHideSkeleton(this.formFields);
      this.$root.$emit('toggleAttachMentGridLoading', false);
    }
  }

  public setFields(callback): void {
    var vm = this;
    this.formFields = [
      {
        key: 'roNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: vm.$parent.$t('repairOrderAttachments.roNumber') as string,
          required: true,
          disabled: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          loading: false,
          rules: [
            v => vm.required('Ro Number', v)
          ]
        },
      },
      {
        key: 'customerName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.customerName') as string,
          required: true,
          disabled: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          loading: false,
          rules: [
            v => vm.required('Customer Name', v)
          ]
        },
      },
      {
        key: 'vehicleIdNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.vinNumber') as string,
          required: true,
          disabled: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          loading: false,
          rules: [
            v => vm.required('VIN Number', v)
          ]
        },
      },
      {
        key: 'make',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.make') as string,
          required: false,
          disabled: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          loading: false,
          // rules:[
          //     v => vm.required('Make',v)
          // ]
        },
      },
      {
        key: 'model',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.model') as string,
          required: false,
          disabled: true,
          elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
          loading: false,
          // rules:[
          //     v => vm.required('Model',v)
          // ]
        },
      },
      {
        key: 'attachmentTypeId',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.attachmentType') as string,
          // validations: 'required',
          required: true,
          disabled: false,
          time: true,
          value: 'id',
          text: 'name',
          items: vm.attachmentTypes,
          elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
          altag: 'Attachment Type',
          loading: false,
          rules: [
            v => vm.required('Attachment Type', v)
          ]
        },
      },
      {
        key: 'isPublic',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.isPublic') as string,
          disabled: false,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
        },
      },
      {
        key: 'file',
        type: 'v-alynk-file-upload',
        required: true,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.attachment') as string,
          required: true,
          disabled: false,
          multiple: false,
          elementClass: 'mt-2',
          events: {
            onChange: (files, ref) => {
              if (files.length > 0) {
                this.isSaveAttachmentLoading = true;
                this.$emit('update:childProgress', this.isSaveAttachmentLoading);
                const field = this.formFields.find((m) => {
                  return m.key === "file";
                });
                if (field != null) {
                  field.templateOptions.disabled = true;
                }
                vm.fileRef = ref;
                // tslint:disable-next-line: max-line-length
                vm.addAttachmentTypeModel.fileExtension = files[0].file.name.substring(files[0].file.name.lastIndexOf('.'));
                FileHelper.getFileBytes(files[0].file, (base64) => {
                  if (base64 != null && base64 != "") {
                    vm.addAttachmentTypeModel.file = base64;
                    this.isSaveAttachmentLoading = false;
                    this.$emit('update:childProgress', this.isSaveAttachmentLoading);
                    if (field != null) {
                      field.templateOptions.disabled = false;
                    }
                  }
                });
              }
            },
          },
          loading: false,
          rules: [
            v => vm.required('Attachment', v)
          ]
        },
      },
      {
        key: 'comment',
        type: 'v-alynk-textarea',
        required: false,
        templateOptions: {
          counter: 250,
          maxlength: 250,
          label: vm.$parent.$t('repairOrderAttachments.comment') as string,
          required: false,
          disabled: false,
          loading: false,
          elementClass: 'col-12 float-left mt-4',
        },

      }];
    callback();
  }
  public updateFlag(flag, value): void {
    this.flags[flag] = value;
  }
  public cancel(): void {
    this.$emit('updateFlag', 'showForm', false);
    this.$destroy();
  }
}
export default SaveAttachmentComponent;
